import { render, staticRenderFns } from "./SplitList.vue?vue&type=template&id=72799d23&scoped=true&"
import script from "./SplitList.vue?vue&type=script&lang=js&"
export * from "./SplitList.vue?vue&type=script&lang=js&"
import style0 from "./SplitList.vue?vue&type=style&index=0&id=72799d23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72799d23",
  null
  
)

export default component.exports